var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useRef, useState } from 'react';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import createMuiTheme from '@material-ui/core/styles/createMuiTheme';
import ThemeProvider from '@material-ui/styles/ThemeProvider';
import makeStyles from '@material-ui/core/styles/makeStyles';
import useTheme from '@material-ui/core/styles/useTheme';
import IconButton from '@material-ui/core/IconButton';
import { Upload as UploadIcon } from 'react-feather';
import GetAppIcon from '@material-ui/icons/GetApp';
import CloseIcon from '@material-ui/icons/Close';
import Button from '@material-ui/core/Button';
import clsx from 'clsx';
import { downloadBlob, downloadServerFile, errorGenerators, getTitleFromPath } from '../functions';
import { useForm, useLanguage, useFormRules, useBaseI18n, useAlert } from '../hooks';
import { linkBlue } from '../constants';
import FormInput from './FormInput';
var FormFile = function (_a) {
    var id = _a.id, description = _a.description, download = _a.download, _b = _a.disabled, disabled = _b === void 0 ? false : _b, helperT = _a.helperText, styleClasses = _a.classes;
    var _c = useState("" + Math.random()), fileKey = _c[0], setFileKey = _c[1];
    var _d = useState(false), fileDownloadLoading = _d[0], setFileDownloadLoading = _d[1];
    var fileInputRef = useRef(null);
    var classes = useStyles();
    var form = useForm();
    var formRules = useFormRules();
    var language = useLanguage();
    var alert = useAlert();
    var uf = useBaseI18n(function (i18n) { return i18n.form.uploadFile; });
    var ft = useBaseI18n(function (i18n) { return i18n.form.fileType; });
    var errors = useBaseI18n(function (i18n) { return i18n.error; });
    var originalTheme = useTheme();
    var filePath = useMemo(function () { return id + "Path"; }, [id]);
    var fileName = useMemo(function () { return getTitleFromPath(form.values[filePath], id); }, [form.values, filePath, id]);
    var accept = useMemo(function () { var _a, _b; return (_b = (_a = formRules[id]) === null || _a === void 0 ? void 0 : _a.accept) !== null && _b !== void 0 ? _b : []; }, [formRules, id]);
    var hasDownload = useMemo(function () { return !!((download === null || download === void 0 ? void 0 : download.fieldNames) && (download === null || download === void 0 ? void 0 : download.label) && (download === null || download === void 0 ? void 0 : download.path)); }, [download]);
    var helperText = useMemo(function () {
        if (helperT)
            return helperT;
        if (!accept.length)
            return undefined;
        var fileTypes = accept.map(function (accept) { return accept.split('/')[1]; });
        return ft + " " + fileTypes.join(', ');
    }, [accept, ft]);
    var theme = useMemo(function () {
        if (fileName)
            return originalTheme;
        return createMuiTheme(__assign(__assign({}, originalTheme), { palette: {
                primary: {
                    main: 'rgba(0, 0, 0, 0)'
                }
            } }));
    }, [fileName, originalTheme]);
    var handleInputChange = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var files, file, _a, _b;
        var _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    files = (_c = event.target.files) !== null && _c !== void 0 ? _c : [];
                    file = files[0];
                    if (!file)
                        return [2 /*return*/, form.setFieldTouched(filePath, true)];
                    if (!!accept.includes(file.type)) return [3 /*break*/, 3];
                    _a = !form.touched[filePath];
                    if (!_a) return [3 /*break*/, 2];
                    return [4 /*yield*/, form.setFieldTouched(filePath, true)];
                case 1:
                    _a = (_d.sent());
                    _d.label = 2;
                case 2: return [2 /*return*/, (_a,
                        form.setFieldError(filePath, errorGenerators.image(language)))];
                case 3:
                    if (!(encodeURIComponent(decodeURIComponent("" + id + file.name)).length > 260)) return [3 /*break*/, 6];
                    _b = !form.touched[filePath];
                    if (!_b) return [3 /*break*/, 5];
                    return [4 /*yield*/, form.setFieldTouched(filePath, true)];
                case 4:
                    _b = (_d.sent());
                    _d.label = 5;
                case 5: return [2 /*return*/, (_b,
                        form.setFieldError(filePath, errorGenerators.fileNameLength(language)))];
                case 6: return [4 /*yield*/, form.setValues(function (values) {
                        var _a;
                        return (__assign(__assign({}, values), (_a = {}, _a[id] = file, _a[filePath] = file.name, _a)));
                    })];
                case 7:
                    _d.sent();
                    form.setFieldTouched(filePath, true);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleInputOpen = function () {
        var _a;
        (_a = fileInputRef.current) === null || _a === void 0 ? void 0 : _a.click();
    };
    var handleDelete = function () {
        form.setFieldTouched(filePath, true);
        form.setValues(function (values) {
            var _a;
            return (__assign(__assign({}, values), (_a = {}, _a[id] = null, _a[filePath] = null, _a)));
        });
        setFileKey("" + Math.random());
    };
    var handleInputClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        var file;
        return __generator(this, function (_a) {
            try {
                if (!fileName)
                    return [2 /*return*/];
                file = form.values[id];
                if (file)
                    return [2 /*return*/, downloadBlob(file, fileName)];
                return [2 /*return*/, downloadServerFile(form.values[filePath], fileName, {}, false, 'GET', true)];
            }
            catch (error) {
                alert(errors.downloadFile);
                console.error(error);
            }
            return [2 /*return*/];
        });
    }); };
    var handleDownload = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    setFileDownloadLoading(true);
                    return [4 /*yield*/, downloadServerFile(download.path, getTitleFromPath(download.path, download.fieldNames), {}, false, 'GET', true)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 2:
                    error_1 = _a.sent();
                    alert(errors.downloadFile);
                    console.error(error_1);
                    return [3 /*break*/, 4];
                case 3:
                    setFileDownloadLoading(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(_Fragment, { children: [_jsx(FormInput, { id: filePath, description: description, readOnly: true, value: fileName, helperText: helperText, classes: __assign({ root: clsx(!fileName && classes.noFileRoot), input: clsx(fileName ? classes.fileInput : classes.noFileInput) }, styleClasses), inputProps: {
                    onClick: handleInputClick
                }, labelAdornment: hasDownload && (_jsx(Button, __assign({ color: "primary", onClick: handleDownload, disabled: fileDownloadLoading || disabled, startIcon: _jsx(GetAppIcon, { className: classes.downloadButtonIcon }, void 0), classes: {
                        root: classes.downloadButton,
                        label: classes.downloadButtonLabel,
                        startIcon: classes.downloadButtonStartIcon
                    } }, { children: download.label }), void 0)), startAdornment: (_jsx(ThemeProvider, __assign({ theme: theme }, { children: _jsx(IconButton, __assign({ color: "primary", disableRipple: true, disableFocusRipple: true, disableTouchRipple: true, className: clsx(classes.fileIcon, !fileName && classes.noFileIcon, classes.iconButton) }, { children: _jsx(InsertDriveFileIcon, { className: classes.svg }, void 0) }), void 0) }), void 0)), endAdornment: fileName ? (_jsx(IconButton, __assign({ color: "primary", onClick: handleDelete, disabled: disabled, className: classes.iconButton }, { children: _jsx(CloseIcon, { className: classes.svg }, void 0) }), void 0)) : (_jsx(Button, __assign({ color: "primary", endIcon: (_jsx(UploadIcon, { className: classes.svg, color: originalTheme.palette.primary.main }, void 0)), classes: {
                        root: classes.uploadButton,
                        label: classes.noFileLabel,
                        endIcon: classes.uploadButtonEndIcon
                    }, onClick: handleInputOpen, disabled: disabled }, { children: uf }), void 0)) }, void 0),
            _jsx("input", { ref: fileInputRef, type: "file", disabled: disabled, className: classes.input, onChange: handleInputChange, accept: accept.join('|') }, fileKey)] }, void 0));
};
export default FormFile;
export var useStyles = makeStyles(function (theme) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return ({
        fileIcon: {
            background: 'transparent !important',
            cursor: 'inherit'
        },
        input: {
            display: 'none'
        },
        noFileInput: {
            width: 0,
            padding: '0 !important'
        },
        uploadButton: {
            width: '100%',
            padding: 0
        },
        fileInput: {
            color: linkBlue,
            textDecoration: 'underline',
            cursor: 'pointer'
        },
        noFileIcon: {
            width: 0,
            paddingLeft: '0 !important',
            paddingRight: '0 !important'
        },
        noFileRoot: {
            alignItems: 'stretch'
        },
        downloadButton: (_a = {},
            _a[theme.breakpoints.up(500)] = {
                padding: '0 5px'
            },
            _a[theme.breakpoints.down(500)] = {
                padding: '0 5.7px'
            },
            _a[theme.breakpoints.up(1600)] = {
                padding: '0 6.5px'
            },
            _a),
        downloadButtonLabel: (_b = {
                fontFamily: 'Assistant-Bold',
                textDecoration: 'underline',
                textTransform: 'none'
            },
            _b[theme.breakpoints.up(500)] = {
                fontSize: 13
            },
            _b[theme.breakpoints.down(500)] = {
                fontSize: 15
            },
            _b[theme.breakpoints.up(1600)] = {
                fontSize: 17
            },
            _b),
        downloadButtonStartIcon: (_c = {
                margin: 0
            },
            _c[theme.breakpoints.up(500)] = {
                marginRight: 5
            },
            _c[theme.breakpoints.down(500)] = {
                marginRight: 5.7
            },
            _c[theme.breakpoints.up(1600)] = {
                marginRight: 6.5
            },
            _c),
        downloadButtonIcon: (_d = {},
            _d[theme.breakpoints.up(500)] = {
                width: 16,
                height: 16
            },
            _d[theme.breakpoints.down(500)] = {
                width: 18,
                height: 18
            },
            _d[theme.breakpoints.up(1600)] = {
                width: 21,
                height: 21
            },
            _d),
        noFileLabel: (_e = {
                fontFamily: 'Assistant-Regular',
                textTransform: 'none'
            },
            _e[theme.breakpoints.up(500)] = {
                fontSize: 17
            },
            _e[theme.breakpoints.down(500)] = {
                fontSize: 22
            },
            _e[theme.breakpoints.up(1600)] = {
                fontSize: 23
            },
            _e),
        iconButton: (_f = {},
            _f[theme.breakpoints.up(500)] = {
                padding: 8.88
            },
            _f[theme.breakpoints.down(500)] = {
                padding: 11.4
            },
            _f[theme.breakpoints.up(1600)] = {
                padding: 12
            },
            _f),
        svg: (_g = {},
            _g[theme.breakpoints.up(500)] = {
                width: 17,
                height: 17
            },
            _g[theme.breakpoints.down(500)] = {
                width: 22,
                height: 22
            },
            _g[theme.breakpoints.up(1600)] = {
                width: 23,
                height: 23
            },
            _g),
        uploadButtonEndIcon: (_h = {},
            _h[theme.breakpoints.up(500)] = {
                marginLeft: 4.4,
                marginRight: -2.2
            },
            _h[theme.breakpoints.down(500)] = {
                marginLeft: 5.7,
                marginRight: -2.8
            },
            _h[theme.breakpoints.up(1600)] = {
                marginLeft: 6,
                marginRight: -3
            },
            _h)
    });
});
//# sourceMappingURL=FormFile.js.map